import React, { useState } from 'react';
import axiosInstance from '../../utils/axiosInstanse';
import host from "../../host";


function PreviewButton({ date_from, date_to }) {
    const [loadingR, setLoadingR] = useState(false);

    const str2DateTime = (dateStr) => {
        if (!dateStr) return '-';

        // Если формат: "18.06.2026 07:54:48"
        const parts = dateStr.split(' ');
        if (parts.length === 2) {
            return `${parts[0]}<br>${parts[1]}`;
        }
        return dateStr;
    };

    const str2VisitorFIO = (fioStr) => {
        if (!fioStr) return '-';

        const parts = fioStr.split(' ');
        return `${parts[0]}<br>${parts.slice(1).join(' ')}`
    }

    const handlePreview = async () => {
        setLoadingR(true);

        try {
            const params = {};
            params.date_from = date_from || null;
            params.date_to = date_to || null;

            const response = await axiosInstance.get(
                `${host}api/get_guests_preview/`,
                { params: { ...params, limit: 50 } }
            );

            const data = response.data.data;
            const total = response.data.total;

            // ✅ Открываем новую ВКЛАДКУ (не окно!)
            const newTab = window.open('', '_blank');

            if (!newTab) {
                alert('Пожалуйста, разрешите всплывающие окна для этого сайта');
                return;
            }

            const styles = `
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { 
                    font-family: 'Segoe UI', Arial, sans-serif; 
                    padding: 20px; 
                    background: #f5f7fa; 
                }
                .container { 
                    max-width: 1400px; 
                    margin: 0 auto; 
                    background: white; 
                    border-radius: 12px; 
                    padding: 20px; 
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                }
                .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #e9ecef;
                }
                .header h1 {
                    color: #1F4E78;
                    font-size: 24px;
                }
                .btn-close {
                    padding: 8px 20px;
                    background: #dc3545;
                    color: white;
                    border: none;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                }
                .btn-close:hover {
                    background: #c82333;
                }
                .info {
                    display: flex;
                    align-items: center;
                    gap: 30px;
                    margin-bottom: 20px;
                    padding: 12px 16px;
                    background: #f8f9fa;
                    border-radius: 8px;
                    font-size: 14px;
                }
                .info strong {
                    color: #1F4E78;
                }
                .table-wrapper {
                    overflow-x: auto;
                    border-radius: 8px;
                    border: 1px solid #dee2e6;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                }
                thead {
                    background: #1F4E78;
                    color: white;
                }
                th {
                    padding: 12px 15px;
                    text-align: left;
                    font-weight: 600;
                    white-space: nowrap;
                }
                td {
                    padding: 10px 15px;
                    border-bottom: 1px solid #e9ecef;
                }
                tbody tr:hover {
                    background: #f8f9fa;
                }
                .status-badge {
                    display: inline-block;
                    padding: 4px 12px;
                    border-radius: 20px;
                    background: #d4edda;
                    color: #155724;
                    font-size: 12px;
                    font-weight: 600;
                }
                .empty {
                    text-align: center;
                    padding: 40px;
                    color: #999;
                    font-size: 16px;
                }
                .footer {
                    margin-top: 20px;
                    padding-top: 15px;
                    border-top: 1px solid #e9ecef;
                    text-align: center;
                    color: #6c757d;
                    font-size: 13px;
                }
            `;

            const rows = data.length === 0 ? `
                <tr>
                    <td colspan="8" class="empty">📭 Нет данных за выбранный период</td>
                </tr>
            ` : data.map(record => `
                <tr>
                    <td>${str2DateTime(record.created_time)}</td>
                    <td>${record.visit_place_name || '-'}</td>
                    <td>${record.come_to || '-'}</td>
                    <td>${str2VisitorFIO(record.visitor_name)}</td>
                    <td>${record.organization || '-'}</td>
                    <td>${record.visit_purpose || '-'}</td>
                    <td>
                        ${record.in_access_point_name || '-'} <br>
                        ${record.came_in || '-'}
                    </td>
                    <td>
                        ${record.out_access_point_name || '-'} <br>
                        ${record.came_out || '-'}
                    </td>
                    
                </tr>
            `).join('');

            // <td><span class="status-badge">${record.status || 'APPROVED'}</span></td>

            newTab.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Предпросмотр отчета</title>
                    <style>${styles}</style>
                </head>
                <body>
                    <div class="container">
                      

                        <div class="info">
                            <span>📋 <strong>Всего записей:</strong> ${total}</span>
                            <span>📄 <strong>Показано:</strong> ${data.length}</span>
                            <span>📅 <strong>Дата формирования:</strong> ${new Date().toLocaleString()}</span>

                            <button class="btn-close" style="margin-left: auto" onclick="window.close()">✕ Закрыть</button>

                        </div>

                        <div class="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Дата создания</th>
                                        <th>Место посещения</th>
                                        <th>К кому</th>
                                        <th>Посетитель</th>
                                        <th>Организация</th>
                                        <th>Цель визита</th>
                                        <th>Вход</th>
                                        <th>Выход</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${rows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </body>
                </html>
            `);

            newTab.document.close();

        } catch (err) {
            alert('Ошибка при загрузке данных: ' + (err.response?.data?.detail || err.message));
            setLoadingR(false);
        } finally {
            setLoadingR(false);
        }
    };

    return (
        <button
            className="pal-btn--secondary pal-filter-btn"
            onClick={handlePreview}
            style={{ padding: '8px 24px', cursor: 'pointer' }}
            disabled={loadingR ? "disabled" : ""}
        >
            {!loadingR ? "👁️ Предпросмотр" : "Пожалуйста, подождите.."}
        </button>
    );
}

export default PreviewButton;